import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 294.000000 291.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,291.000000) scale(0.100000,-0.100000)" >


<path d="M1260 1755 c0 -30 -3 -54 -7 -54 -22 4 -32 -4 -43 -31 -19 -45 5 -97
43 -91 4 0 7 -22 7 -49 l0 -50 74 0 c82 0 103 -12 92 -55 -6 -24 -9 -25 -87
-25 l-80 0 3 -62 3 -63 104 2 c117 3 144 14 167 68 26 64 9 176 -30 191 -13 5
-12 9 4 27 11 11 20 25 20 29 0 5 -63 8 -139 7 -77 0 -144 2 -150 6 -15 9 -14
58 1 73 8 8 58 12 160 12 136 0 147 1 142 18 -30 91 -49 102 -183 102 l-101 0
0 -55z"/>
<path d="M1665 1755 c-19 -30 -35 -57 -35 -60 0 -3 28 -5 63 -5 l62 0 38 60
37 60 -65 0 -65 0 -35 -55z"/>
<path d="M1113 1743 c-21 -37 -28 -61 -28 -103 0 -42 7 -66 28 -103 15 -26 34
-47 42 -47 21 0 19 6 -12 46 -37 49 -43 125 -14 182 11 22 25 43 31 47 15 9
12 25 -5 25 -8 0 -27 -21 -42 -47z"/>
<path d="M1178 1733 c-26 -30 -38 -60 -38 -95 0 -36 31 -95 55 -105 28 -10 28
5 1 37 -32 39 -34 91 -6 138 11 18 20 35 20 37 0 11 -18 4 -32 -12z"/>
<path d="M1271 1648 c-1 -16 4 -28 10 -28 5 0 7 5 3 12 -5 7 -2 9 8 5 12 -4
14 -1 10 15 -3 13 -7 16 -12 8 -6 -9 -9 -9 -13 1 -3 8 -6 2 -6 -13z"/>
<path d="M1540 1646 c0 -14 4 -26 9 -26 5 0 7 9 4 20 -7 25 13 27 21 3 4 -14
4 -14 3 2 -1 11 -10 21 -20 23 -12 3 -17 -3 -17 -22z"/>
<path d="M1336 1647 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M1606 1646 c5 -13 4 -17 -4 -12 -7 4 -12 2 -12 -3 0 -14 17 -14 26 0
3 6 1 16 -5 22 -9 9 -10 7 -5 -7z"/>
<path d="M1677 1644 c5 -13 3 -15 -7 -9 -9 5 -11 4 -6 -3 4 -7 11 -12 17 -12
12 0 12 27 -1 35 -6 4 -7 -1 -3 -11z"/>
<path d="M1471 1634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1492 1630 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1511 1634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1570 1545 c0 -50 6 -65 65 -165 l66 -110 65 0 c55 0 65 3 60 15 -3
9 -38 70 -77 138 -74 125 -76 130 -64 160 6 15 0 17 -54 17 l-61 0 0 -55z"/>
<path d="M1210 1095 c0 -108 1 -115 20 -115 16 0 20 7 20 35 0 45 18 45 48 0
13 -21 30 -35 42 -35 18 0 19 3 9 23 -7 12 -21 35 -32 50 l-19 28 26 28 c31
32 32 41 7 41 -11 0 -29 -13 -41 -30 -12 -16 -26 -30 -31 -30 -5 0 -9 27 -9
60 0 53 -2 60 -20 60 -19 0 -20 -7 -20 -115z"/>
<path d="M668 1193 c-16 -4 -18 -18 -18 -109 l0 -104 60 0 c80 0 120 20 120
60 0 18 -8 34 -20 43 -18 13 -19 16 -5 27 18 15 20 54 2 68 -14 12 -112 23
-139 15z m107 -58 c0 -16 -8 -21 -42 -23 -40 -3 -43 -2 -43 23 0 25 3 26 43
23 34 -2 42 -7 42 -23z m0 -69 c32 -23 12 -46 -40 -46 -43 0 -45 1 -45 30 0
27 3 30 33 30 18 0 42 -6 52 -14z"/>
<path d="M1773 1194 c-9 -4 -13 -36 -13 -110 l0 -104 45 0 c69 0 113 22 131
67 20 46 6 105 -30 128 -25 16 -112 29 -133 19z m109 -51 c23 -20 24 -85 2
-107 -8 -9 -31 -16 -50 -16 l-34 0 0 70 0 70 32 0 c17 0 40 -7 50 -17z"/>
<path d="M2157 1160 c-19 -22 -22 -40 -7 -40 5 0 10 -30 12 -67 l3 -68 33 -3
c24 -2 32 1 32 12 0 9 -7 16 -15 16 -12 0 -15 13 -15 55 0 42 3 55 15 55 8 0
15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 21 -22 19 -43 -5z"/>
<path d="M893 1140 c-28 -12 -30 -40 -3 -40 11 0 20 5 20 10 0 16 37 11 44 -6
9 -23 8 -24 -25 -24 -45 0 -69 -16 -69 -48 0 -16 5 -33 12 -40 16 -16 54 -15
70 2 11 12 15 12 30 -1 10 -9 24 -13 33 -10 17 7 21 27 5 27 -5 0 -10 23 -10
50 0 76 -41 106 -107 80z m67 -86 c0 -3 -5 -14 -10 -25 -18 -33 -59 -18 -46
16 5 14 56 22 56 9z"/>
<path d="M1055 1125 c-52 -51 -16 -145 55 -145 29 0 70 29 70 50 0 16 -37 11
-44 -6 -3 -9 -15 -14 -28 -12 -20 3 -23 10 -26 51 -4 54 16 71 47 43 18 -16
51 -22 51 -8 -1 23 -45 52 -80 52 -11 0 -32 -11 -45 -25z"/>
<path d="M1380 1081 c0 -50 4 -74 16 -85 20 -21 53 -20 76 1 17 15 18 15 18 0
0 -10 8 -17 20 -17 18 0 20 7 20 85 0 78 -2 85 -20 85 -16 0 -20 -7 -21 -37
-2 -90 -15 -117 -47 -97 -12 8 -18 28 -20 73 -3 53 -6 61 -22 61 -18 0 -20 -7
-20 -69z"/>
<path d="M1570 1035 c0 -108 1 -115 20 -115 17 0 20 7 20 40 0 37 2 40 19 30
52 -27 91 3 91 71 0 62 -23 93 -63 85 -17 -4 -35 -12 -39 -19 -5 -8 -8 -7 -8
6 0 10 -8 17 -20 17 -19 0 -20 -7 -20 -115z m98 73 c17 -17 15 -73 -3 -88 -34
-28 -68 27 -46 76 12 26 30 31 49 12z"/>
<path d="M1997 1132 c-10 -10 -17 -22 -17 -25 0 -11 35 -8 47 4 15 15 43 4 43
-16 0 -10 -10 -15 -34 -15 -19 0 -42 -7 -50 -16 -45 -45 8 -104 64 -72 24 14
29 14 34 2 7 -19 46 -18 46 1 0 8 -4 15 -10 15 -5 0 -10 24 -10 54 0 45 -4 58
-22 70 -30 21 -71 20 -91 -2z m71 -88 c-5 -25 -35 -41 -49 -27 -9 9 -9 16 1
28 17 21 52 20 48 -1z"/>
<path d="M2272 1134 c-12 -8 -22 -19 -22 -25 0 -12 37 -12 45 1 12 19 45 11
45 -10 0 -16 -7 -20 -33 -20 -36 0 -67 -25 -67 -53 0 -40 64 -63 91 -31 11 14
13 14 21 0 9 -16 39 -22 51 -10 3 4 0 16 -8 28 -8 11 -15 42 -15 68 0 37 -4
50 -19 58 -28 14 -63 12 -89 -6z m68 -93 c0 -17 -18 -31 -41 -31 -10 0 -12 33
-2 43 14 15 43 7 43 -12z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
